import React from 'react';
import ReactDOM from 'react-dom';

import PlayerApp from './components/App';

class GamePlayerUI {
    // constructor() {}

    render() {
        ReactDOM.render(
            <PlayerApp />,
            document.getElementById('gameplayer')
        );
    }
}

export default GamePlayerUI;
